exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".prod-image[data-v-da49cab4] {\n  background-color: #ebebeb;\n}\n.prod-image img[data-v-da49cab4] {\n  vertical-align: text-bottom;\n}\n", ""]);

// exports
